export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  minrole?: number
  children?: INavigationRoute[]
  onlyAgency?: boolean
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      minrole: 0,
      displayName: 'menu.dashboard',
      meta: {
        icon: 'vuestic-iconset-dashboard',
      },
      disabled: true,
    },
    {
      name: 'actions',
      minrole: 1,
      displayName: 'global.actions',
      meta: {
        icon: 'vuestic-iconset-files',
      },
      children: [
        {
          name: 'actionlist',
          displayName: 'menu.list',
          minrole: 1,
        },
        {
          name: 'actioncreate',
          displayName: 'global.create',
          minrole: 1,
        },
        {
          name: 'actiontemplates',
          displayName: 'menu.predefined-selections',
          minrole: 1,
        },
        {
          name: 'postprocessfilters',
          displayName: 'actions.postprocessfilters',
          minrole: 1,
        },
        {
          name: 'uploadunsubscribes',
          displayName: 'menu.uploadunsubscribes',
          minrole: 1,
          onlyAgency: true,
        },
        {
          name: 'petitiontemplates',
          displayName: 'menu.petitiontemplates',
          minrole: 1,
          onlyAgency: true,
        },
      ],
    },
    {
      name: 'crm',
      displayName: 'global.crm',
      minrole: 1,
      meta: {
        icon: 'material-icons-group_add',
      },
      disabled: true,
      children: [
        {
          name: 'clients',
          displayName: 'crm.clients',
          minrole: 1,
        },
        {
          name: 'beneficiaries',
          displayName: 'crm.beneficiaries',
          minrole: 1,
        },
        {
          name: 'informoptoutssettings',
          displayName: 'crm.inform_optouts_settings',
          minrole: 1,
        },
        {
          name: 'informoptoutspartnersettings',
          displayName: 'crm.inform_optouts_partnersettings',
          minrole: 1,
          onlyAgency: true,
        },
        {
          name: 'deliverysettings',
          displayName: 'crm.delivery_settings',
          minrole: 1,
        },
        {
          name: 'blacklists',
          displayName: 'actions.blacklists',
          minrole: 1,
        },
        {
          name: 'defaultvalues',
          displayName: 'crm.default_values',
          minrole: 2,
        },
      ],
    },
    {
      name: 'stats',
      displayName: 'menu.statistics',
      minrole: 0,
      meta: {
        icon: 'vuestic-iconset-statistics',
      },
      disabled: true,
      children: [
        {
          name: 'participations',
          displayName: 'actions.participations',
          minrole: 1,
        },
        {
          name: 'samplesregarding',
          displayName: 'crm.samples_regarding',
          minrole: 1,
        },
        {
          name: 'inventory',
          displayName: 'menu.inventory',
          minrole: 0,
        },
        {
          name: 'blocks',
          displayName: 'actions.blocks',
          minrole: 0,
        },
        {
          name: 'robinson',
          displayName: 'Robinson',
          minrole: 1,
        },
      ],
    },
    {
      name: 'system',
      displayName: 'menu.system',
      minrole: 2,
      meta: {
        icon: 'vuestic-iconset-settings',
      },
      disabled: true,
      children: [
        {
          name: 'users',
          displayName: 'global.users',
          minrole: 2,
        },
        {
          name: 'sources',
          displayName: 'global.sources',
          minrole: 2,
        },
        {
          name: 'categories',
          displayName: 'global.categories',
          minrole: 2,
        },
        {
          name: 'deliveryformats',
          displayName: 'crm.delivery_formats',
          minrole: 2,
        },
        {
          name: 'actiontools',
          displayName: 'Action tools',
          minrole: 2,
        },
        {
          name: 'partners',
          displayName: 'crm.partners',
          minrole: 2,
          onlyAgency: true,
        },
      ],
    },
    {
      name: 'myaccount',
      minrole: 1,
      displayName: 'menu.myaccount',
      meta: {
        icon: 'vuestic-iconset-user',
      },
    },
  ] as INavigationRoute[],
}
